<template>
  <div class="main" style="background:#fff">
    <div class="px-3 py-3">
        <div class="flex flex-start justify-between">
          <div class="item-name">{{goods.title}}</div>
          <div style="display:flex">
            <span v-if="goods && goods.productprice"
            style="font-size:13px;-webkit-text-decoration-line: line-through; /* Safari */; 
            text-decoration-line: line-through;color:#ee2d24;margin-top:3px "
            >{{ fmPrice(goods.productprice)}}</span>
            <div class="item-price">
            <span>{{ fmPrice(goods.price || goods.marketprice)}}</span>
            <div v-if="goods.goods_attr_list.length" class="base-price">{{ $t("translate.base_price") }}</div>
          </div>
          </div>
        </div>
    </div>

    <!-- condiment filter cart list -->
    <div class="px-3 py-3 mb-2 item"> 
      <div v-for="item in filterItemCart" :key="item.id" class="flex justify-between py-2" style="border-top:1px solid rgb(231, 231, 231);">
        <div>
        <div>
          <div  class="optionname-word">
              <span v-for="optionname in item.optionname" :key="optionname.id">
              <span class="item-option-attr">{{optionname}}</span>
              </span>
          </div>
        </div>

          <div @click="edit(item)" class="flex flex-center ml-1 mt-1 " style="cursor:pointer;width:fit-content">
            <span class="mr-1 size12" style="color:rgb(215 15 100)">Edit</span>
            <van-icon name="edit" size="18" color="rgb(215 15 100)" />
          </div>
        </div>
        <div class="flex flex-end size12 ml-2" style="flex-direction:column">
          <span> {{ fmPrice( parseFloat(item.price) * parseInt(item.qty)) }} </span>
          <span class="mt-1">{{item.qty}}x</span>
        </div>

      </div>
    </div>

    <div class="px-3 py-3" style="width:100%;box-shadow:0 -5px 15px 0 #cccbcb">
      <v-btn @click="newItem" class="bg-main" style="width:100%">
        Make Another
      </v-btn>
    </div>

  </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import { cartMixin } from "@/mixins/cartMixin";

export default {
  props: {
    // 当前商品
    goods: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  created() {
    this.filterCondiments()
  },
  data() {
    return{
      filterItemCart: []
    }
  },
  mixins: [cartMixin],
  computed: {
    ...mapGetters([
      'cart_goodslist',
    ])
  },
  methods: {
    filterCondiments() { 
      let filterCartLists = this.cart_goodslist.filter(cartlist => cartlist.goods_id == this.goods.id )
      console.log('filter cart lists', filterCartLists)
      this.filterItemCart = filterCartLists
    },
    edit(item) {
      this.$emit('evtEditFilterItem',item)
      this.$emit('close')
    },
    newItem() {
      this.$emit('evtFilterItem',this.goods)
      this.$emit('close')
    }
  }
}

</script>

<style lang="less" scoped> 
@import url('../../assets/css/common.less');
@import url("../../assets/css/global.less");

.item-name {
  font-weight: bold;
  font-size: 16px;
}
.item-price {
  padding: 0 0 0 8px;
  font-weight: bold;
  font-size: 18px;
  }
.base-price {
  width: 60px;
  font-size: 12px;
  color: @gray8;
  font-weight: normal;
}
.optionname-word {
    word-break: break-all;
    word-wrap: break-word;
}
.item-option-attr {
    // color: #666666;
    color: @gray8;
    font-size: 12px;
    // border: 1px solid #cecece;
    border: 1px solid @white14;
    padding: 0px 3px;
    margin: 2px;
    border-radius: 2px;
    display: inline-block;
}
</style>